import React, { Component } from 'react';
import FormExplanationValidation from './FormExplanationValidation';
declare var $;

// button class => icon-only btn-icon btn

class FormDatePickerInput extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    componentDidMount() {
        var _this = this;

        $('[data-toggle="tooltip"]').tooltip();

        this.$el = $(this.el);
        this.$el.datepicker({
            showOn: "both",
            buttonText: "<i aria-hidden='true' class='icon-calendar'></i><span class='sr-only'>Calendar</span>",
            changeMonth: true,
            changeYear: true,
            yearRange: 'c-70:c+10',
            showOtherMonths: true,
            selectOtherMonths: true,
            afterShow: function() {
                $("#ui-datepicker-div, #ui-datepicker-div *[class^='ui-']").each(function(i, elm ) {
                    var css = elm.className.split(/\s+/);
                    for (var iCss = 0; iCss < css.length; iCss++) {
                        if (css[iCss].match("^ui-")) {
                            $(elm).addClass("datetime-" + css[iCss]);
                        }
                    }
                });                                     
            },
            onSelect: function() {
                var e = {
                    target: this
                }
                _this.onChange(e)
            }
        }).next(".ui-datepicker-trigger").addClass("icon-only btn-icon btn");
    }

    componentWillUnmount() {
        $('[data-toggle="tooltip"]').tooltip("destroy");
        this.$el.datepicker('destroy');
    }     

    onChange(e) {
        this.props.onChange(e);
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            
            if (this.props.onEnter == null) {
                return;
            }
            this.props.onEnter(e);
        }
    }

    render() {

        let toolTip = !!this.props.tooltip ? <i id={"tooltip-" + this.props.id} class="fa fa-info-circle info-tooltip" data-html="true" data-toggle="tooltip" data-placement="right" aria-hidden="true" title={this.props.tooltip}></i> : null;
        let requiredMark = this.props.required && !this.props.readonly ? <span className="required-mark">*</span> : null;
        var autocomplete = (this.props.autocomplete) ? this.props.autocomplete : "no-autocomplete";
        
        return (
            <div className="tr">
                <div className="FieldLabel td">
                    <label htmlFor={this.props.readonly ? null : this.props.id}>{this.props.text}
                        {toolTip}
                        {requiredMark}
                    </label>
                </div>
                {
                    (this.props.readonly) ?
                        <div className="EditingFormValueCell td"><p className="form-control-static">{this.props.value}</p></div> : 
                        <div className="EditingFormValueCell td">
                            <div className="date-time-picker">
                                <div className="control-group-inline">
                                    <input type="text" ref={el => this.el = el} id={this.props.id} autoComplete={autocomplete} maxLength={this.props.maxlength} className="form-control CalendarTextBox" onChange={this.onChange} onKeyPress={this.onKeyPress} value={this.props.value} />
                                </div>
                            </div>
                            <FormExplanationValidation id={this.props.id} explanation={this.props.explanation} showValidation={this.props.showValidation} validationText={this.props.validationText} />
                        </div>
                }
                </div>
        );
    }
}

export default FormDatePickerInput;


// WEBPACK FOOTER //
// ./src/Fields/FormDatePicker.js